import { dispatchMessage, EventType } from 'app/useToasts';
import { i18n } from 'app/utils/i18n';

export type ReportFlow = 'export' | 'validation';

const CODE_SUFFIX: Record<string, string> = {
  TAXONOMY_CONFIG_REQUIRED: 'taxonomy_config_required',
  NO_TAGS: 'no_tags',
  MISSING_UNIT_FOR_NUMERIC_FACT: 'missing_unit_for_numeric_fact',
  TAXONOMY_FAMILY_UNSUPPORTED: 'taxonomy_family_unsupported',
  NOTES_PARENT_NOT_FOUND: 'notes_parent_not_found',
  XMLNS_PREFIX_COLLISION: 'xmlns_prefix_collision',
  VALIDATOR_WARMING: 'warming',
};

export function reportErrorKey(flow: ReportFlow, code: string | undefined): string {
  const suffix = code ? CODE_SUFFIX[code] : undefined;
  return suffix ? `tag.${flow}.error.${suffix}` : `tag.${flow}.error.generic`;
}

function extractResponseCode(err: any): string | undefined {
  const direct = err?.response?.data?.code;
  if (typeof direct === 'string') return direct;

  const xhr = err?.request;
  if (!xhr) return undefined;

  let raw: string | undefined;
  try {
    if (typeof xhr.responseText === 'string') raw = xhr.responseText;
  } catch {
    // responseText throws when responseType is 'blob'/'arraybuffer'
  }
  if (!raw && typeof xhr.response === 'string') raw = xhr.response;
  if (!raw) return undefined;

  try {
    const parsed = JSON.parse(raw);
    return typeof parsed?.code === 'string' ? parsed.code : undefined;
  } catch {
    return undefined;
  }
}

export function dispatchReportError(flow: ReportFlow, err: any): void {
  const code = extractResponseCode(err);
  console.error(`[${flow}] report error`, { status: err?.status, code, err });
  dispatchMessage(EventType.ADD_MESSAGE, { type: 'error', text: i18n(reportErrorKey(flow, code)), removeTime: 6000 });
}

export function dispatchReportErrorKey(flow: ReportFlow): void {
  dispatchMessage(EventType.ADD_MESSAGE, { type: 'error', text: i18n(`tag.${flow}.error.generic`), removeTime: 6000 });
}
